import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'
import { URL_SERVICIOS_LOCALES, URL_SERVICIOS_LOCALES_IMPRESORA, MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO, URL_SERVICIOS_AWS,NUBE_AWS, URL_SQS_AWS } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';
import { Store } from '@ngrx/store';
import { AppState } from '../../pages/app.reducer';
import { ParametrosGeneralesRedux } from '../redux/parametrosgenerales/parametrosgenerales';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UtilsProvider } from '../utils/utils';
import { ConceptosEgresosPageModule } from '../../pages/conceptos-egresos/conceptos-egresos.module';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/defer';
@Injectable()
export class CajaProvider {
    token:string
    urlPrintService:string
    companiaId:number
    usuarioId: number;
    cachedData: any = null;
    private datosAdicionales: any = {};
    fechaVenta:any = undefined
    constructor(
        private store: Store<AppState>,
        public http: Http, private storage:Storage,
        private _electronService: ElectronService,
        public utils:UtilsProvider,
        private storePedidosSalon: Store<AppState>,) {
          this.storage.get('token').then((val) => {
            this.token = val
        });

        this.storage.get('companiasId').then(async (val) => {
            this.companiaId = val
        })

        this.storage.get('urlPrint').then((val) => {
            this.urlPrintService = val
        });

        this.storage.get('usuariosId').then((usuario) => {
            this.usuarioId = usuario
        });
        this.storage.get('fechaSistema').then((fechaSistema) => {
          this.fechaVenta = fechaSistema
      });

    }


    buscarGruposProductosParaCaja(companiaId) {
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "gruposProductosParaCaja",
          parameters : {companiaId: companiaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/proceso/gruposProductosParaCaja?companiaId=${companiaId}`)
            .map((data) => data.json())
      }
    }

    buscarGruposProductosParaCajaTendero(companiaId) {
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "gruposProductosParaCajaTendero",
          parameters : {companiaId: companiaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/proceso/gruposProductosParaCaja?companiaId=${companiaId}`)
            .map((data) => data.json())
      }
    }
    productosAgrupados(companiaId) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "productosAgrupados",
          parameters : {companiaId: companiaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/proceso/productosAgrupados?companiaId=${companiaId}`)
              .map((data) => data.json())
     }
    }


    buscarGruposProductosParaCajaComandas(companiaId) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "gruposProductosParaCajaComandas",
          parameters : {companiaId:companiaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/proceso/gruposProductosParaCajaComandas?companiaId=${companiaId}`)
              .map((data) => data.json())
     }
    }

    buscarClientes (text){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarCliente",
          parameters : {datoBusca: text}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options)
            .map((data: any) =>
             {
               let  dataNew = JSON.parse(data._body).data
               return dataNew[0].map((item, index) => {
                  console.log(item)
                  return {
                    display: item.nombreCliente,
                    value: item.clientesId
                }})});
      } else {
          const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarCliente?datoBusca=${text}`;
          return this.http
              .get(url)
              .map(data => data.json()[0].map(item => {
                  return {
                      display: item.nombreCliente,
                      value: item.clientesId
                  }
              } ));
      }
    }

    buscarClientesPorCompania (text, companiaId?: string){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let valuecompaniaId = this.companiaId == null ? companiaId: this.companiaId
        let data = {
          name: "buscarClientesPorCompania",
          parameters : {datoBusca: text,companiasId:valuecompaniaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options)
            .map((data: any) =>
             {
               let  dataNew = JSON.parse(data._body).data
               return dataNew[0].map((item, index) => {
                  console.log(item)
                  return {
                    display: item.nombreCliente,
                    value: item.clientesId
                }})});
      } else {
          const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarClientesPorCompania?datoBusca=${text}&companiasId=${this.companiaId}`;
          return this.http
              .get(url)
              .map(data => data.json()[0].map(item => {
                  return {
                      display: item.nombreCliente,
                      value: item.clientesId
                  }
              } ));
        }
    }

    buscarClientesTelefono (text){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarClienteTelefono",
          parameters : {datoBusca: text}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options)
            .map((data: any) =>
             {
               let  dataNew = JSON.parse(data._body).data
               return dataNew[0].map((item, index) => {
                  console.log(item)
                  return {
                    display: item.nombreCliente,
                    value: item.clientesId
                }})});
      } else {
          const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarClienteTelefono?datoBusca=${text}`;
          return this.http
              .get(url)
              .map(data => data.json()[0].map(item => {
                  return {
                      display: item.nombreCliente,
                      value: item.clientesId
                  }
                } ));
        }
    }

    buscarClientesTelefonoPorCompania (text){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarClientesTelefonoPorCompania",
          parameters : {datoBusca: text,companiasId:this.companiaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options)
            .map((data: any) =>
             {
               let  dataNew = JSON.parse(data._body).data
               return dataNew[0].map((item, index) => {
                  console.log(item)
                  return {
                    display: item.nombreCliente,
                    value: item.clientesId
                }})});
      } else {
          const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarClientesTelefonoPorCompania?datoBusca=${text}&companiasId=${this.companiaId}`;
          return this.http
              .get(url)
              .map(data => data.json()[0].map(item => {
                  return {
                      display: item.nombreCliente,
                      value: item.clientesId
                  }
              } ));
        }
    }


    buscarUsuario (text){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarUsuario",
          parameters : {datoBusca: text}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options)
            .map((data: any) =>
             {
               let  dataNew = JSON.parse(data._body).data
               return dataNew[0].map((item, index) => {
                  console.log(item)
                  return {
                    display: item.nombreCliente,
                    value: item.clientesId
                }})});
      } else {
          const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarUsuario?datoBusca=${text}`;
          return this.http
              .get(url)
              .map(data => data.json()[0].map(item => {
                  return {
                      display: item.nombreUsuario,
                      value: item.usuariosId
                  }
              } ));
        }
    }


  buscarClientesPorCompaniaAll (text){
    if(NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarClientesPorCompaniaAll",
        parameters : {companiasId: text}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option

      return this.http.post(`${url_servicio}/procedure`, data, options)
          .map((data: any) =>
           {
             let  dataNew = JSON.parse(data._body).data
             return dataNew[0].map((item, index) => {
                return {
                  display: item.nombreCliente,
                  value: item.clientesId
              }})});
    } else {
      const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarClientesPorCompaniaAll?companiasId=${this.companiaId}`;
      return this.http
          .get(url)
          .map(data => data.json()[0].map(item => {
              return {
                  display: item.nombreCliente,
                  value: item.clientesId
              }
          } ));
    }
  }


      buscarUsuarioPorEmpresaFiltro (text){
        if(NUBE_AWS) {
          const url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarUsuarioPorEmpresaFiltro",
            parameters : {datoBusca:text,companiasId: this.companiaId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option

          return this.http.post(`${url_servicio}/procedure`, data, options)
              .map((data: any) =>
               {
                 let  dataNew = JSON.parse(data._body).data
                 return dataNew[0].map((item, index) => {
                    console.log(item)
                    return {
                      display: item.nombreUsuario,
                      value: item.usuariosId
                  }})});
        } else {
        const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarUsuarioPorEmpresaFiltro?datoBusca=${text}&companiasId=${this.companiaId}`;
        return this.http
            .get(url)
            .map(data => data.json()[0].map(item => {
                return {
                    display: item.nombreUsuario,
                    value: item.usuariosId
                }
            } ));
          }
    }

    buscarUsuarioPorEmpresa (companiaId){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarUsuarioPorEmpresa",
          parameters : {companiasId:companiaId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options)
            .map((data: any) =>
             {
               let  dataNew = JSON.parse(data._body).data
               return dataNew[0].map((item, index) => {
                  console.log(item)
                  return {
                    display: item.nombreUsuario,
                    value: item.usuariosId
                }})});
      } else {
      const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarUsuarioPorEmpresa?companiasId=${companiaId}`;
      return this.http
          .get(url)
          .map(data => data.json()[0].map(item => {
              return {
                  display: item.nombreUsuario,
                  value: item.usuariosId
              }
          } ));
        }
  }

    imprimirRecibo (text) {
        const url = this.urlPrintService || URL_SERVICIOS_LOCALES_IMPRESORA

        const headers = new Headers({
            'Content-Type': 'application/json'
        })

        const options = new RequestOptions({
            headers: headers
        })
        text = text.substring(0, text.length - 1);
        let textResponse = text.split("undefined").join('')
        return this.http
            .post(url, {text: textResponse, texto:textResponse, cut: true, cash: true}, options)
    }
 // const urlDian = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cufe}`;


//  imprimirReciboCufe(text, cufe: any = undefined) {
//   return Observable.fromPromise(
//     this.imprimirReciboCufePromesa(text, cufe)
//       .then(res => res || null) // Asegura que siempre devuelve algo
//   ).subscribe(
//     res => {
//       console.log("Impresión exitosa:", res);
//     },
//     error => {
//       console.error("Error al imprimir el recibo:", error);
//     }
//   );
//  }

//  imprimirReciboCufe(text, cufe: any = undefined) {
//   const url = this.urlPrintService || URL_SERVICIOS_LOCALES_IMPRESORA;

//   const headers = new Headers({
//     'Content-Type': 'application/json',
//   });

//   const options = new RequestOptions({
//     headers: headers,
//   });

//   text = text.substring(0, text.length - 1);
//   let textResponse = text.split("undefined").join("");

//   // cufe = '1cca40bc973ea81305e40b75427782bc6aa8d3a6c0e9ede7471e55665e48600cad58619ea89f214448317590ecbfc834';

//   if (cufe !== undefined) {
//     const titulo = 'Cufe / Cude';
//     const urlOriginal = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cufe}`;

//     // Retornamos la promesa correctamente
//     return this.acortarUrlTiny(urlOriginal).then(urlDian => {
//       const alignCenterCommand = '\x1B\x61\x01'; // 0 = izquierda, 1 = centro, 2 = derecha

//       textResponse += '\n';
//       textResponse += alignCenterCommand + titulo + '\n';
//       textResponse += cufe + '\n';
//       textResponse += alignCenterCommand + urlDian + '\n';

//       const qrModuleSize = 6;
//       const qrModuleSizeCommand = `\x1D\x28\x6B\x03\x00\x31\x43${String.fromCharCode(qrModuleSize)}`;

//       const qrAlignCenterCommand = '\x1B\x61\x01';
//       const qrCodeCommand =
//         '\x1D\x28\x6B' +
//         String.fromCharCode(urlDian.length + 3, 0) +
//         '\x31\x50\x30' +
//         urlDian  +
//         '\x1D\x28\x6B\x03\x00\x31\x51\x30';

//       textResponse += '\n';
//       textResponse += qrAlignCenterCommand + qrModuleSizeCommand + qrCodeCommand;

//       // Aquí sí retornamos la petición HTTP
//       return this.http.post(
//         url,
//         { text: textResponse, texto: textResponse, cut: true, cash: true },
//         options
//       ).toPromise(); // Convertimos a promesa para manejarlo bien
//     });
//   }

//   // En caso de que no haya CUFE, retornamos una promesa resuelta.
//   return Promise.resolve();
// }


imprimirReciboCufe(text: string, cufe: any = undefined): Observable<any> {
  const url = this.urlPrintService || URL_SERVICIOS_LOCALES_IMPRESORA;

  const headers = new Headers({
    'Content-Type': 'application/json',
  });

  const options = new RequestOptions({ headers });

  text = text.substring(0, text.length - 1);
  let textResponse = text.split("undefined").join("");

  if (cufe !== undefined) {
    const titulo = 'Cufe / Cude';
    const urlOriginal = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cufe}`;

    return Observable.fromPromise(
      this.acortarUrlTiny(urlOriginal).then(urlDian => {
        const alignCenterCommand = '\x1B\x61\x01'; // Centrar texto
        const qrModuleSize = 6;
        const qrModuleSizeCommand = `\x1D\x28\x6B\x03\x00\x31\x43${String.fromCharCode(qrModuleSize)}`;

        textResponse += `\n${alignCenterCommand}${titulo}\n${cufe}\n${alignCenterCommand}${urlDian}\n`;

        const qrCodeCommand =
          '\x1D\x28\x6B' +
          String.fromCharCode(urlDian.length + 3, 0) +
          '\x31\x50\x30' +
          urlDian +
          '\x1D\x28\x6B\x03\x00\x31\x51\x30';

        textResponse += `\n${alignCenterCommand}${qrModuleSizeCommand}${qrCodeCommand}`;

        return this.http.post(url, { text: textResponse, cut: true, cash: true }, options).toPromise();
      })
    );
  }

  // Si no hay CUFE, devolver un observable con una respuesta vacía
  return Observable.fromPromise(Promise.resolve({ message: "No se envió CUFE" }));
}
acortarUrlTiny(url: string): Promise<string> {
  return this.http.get(`https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`)
    .toPromise()
    .then((response: any) => response.text()) // TinyURL devuelve la URL corta en texto plano
    .catch(error => {
      console.error('Error acortando URL:', error);
      return url; // Si falla, usa la URL original
    });
}



    // acortarUrlTiny(url: string): Promise<string> {
    //   return this.http.get(`https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`)
    //     .toPromise()
    //     .then((response: any) => response.text()) // TinyURL devuelve la URL corta como texto plano
    //     .catch(error => {
    //       console.error('Error acortando URL:', error);
    //       return url; // Si falla, usa la URL original
    //     });
    // }



  // imprimirReciboCufe(text, cufe: any = undefined) {
  //   const url = this.urlPrintService || URL_SERVICIOS_LOCALES_IMPRESORA;

  //   const headers = new Headers({
  //     'Content-Type': 'application/json',
  //   });

  //   const options = new RequestOptions({
  //     headers: headers,
  //   });

  //   text = text.substring(0, text.length - 1);
  //   let textResponse = text.split("undefined").join("");
  //   cufe = '1cca40bc973ea81305e40b75427782bc6aa8d3a6c0e9ede7471e55665e48600cad58619ea89f214448317590ecbfc834'
  //   if (cufe !== undefined) {
  //     const titulo = 'Cufe / Cude';
  //     const urlDian = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cufe}`;
  //     //documentkey=1b9dd52bc8b816ef8b25d4e984661420dbd5393e0b16fe021b0555db2830983d0d4917cf762fe4aa7ac6bbdd5d8681e7
  //     // Agregar alineación centrada para el título
  //     const alignCenterCommand = '\x1B\x61\x01'; // 0 = izquierda, 1 = centro, 2 = derecha

  //     textResponse += '\n';
  //     // Agregar el título centrado
  //     textResponse += alignCenterCommand + titulo + '\n'; // Agrega el título y un salto de línea
  //     textResponse += cufe + '\n';

  //     // Agregar la URL debajo del CUFE
  //     textResponse += alignCenterCommand + urlDian + '\n';

  //     // Ajustar el tamaño del módulo QR
  //     const qrModuleSize = 6; // Aumenta este valor según sea necesario
  //     const qrModuleSizeCommand = `\x1D\x28\x6B\x03\x00\x31\x43${String.fromCharCode(qrModuleSize)}`;

  //     // Comando para centrar el QR
  //     const qrAlignCenterCommand = '\x1B\x61\x01'; // 0 = izquierda, 1 = centro, 2 = derecha
  //     //String.fromCharCode(urlDian.length + 3, 0) +
  //     //https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=1cca40bc973ea81305e40b75427782bc6aa8d3a6c0e9ede7471e55665e48600cad58619ea89f214448317590ecbfc834
  //     //https://catalogo-vpfe.dian.gov.co/document/searchqr
  //     const base64Url = cufe // 'https://urldn.com/BkH5q/document/searchqr?documentkey='+cufe;
  //     //https://urldn.com/F7-jR/Mb0881b9dd52bc8b816ef8b25d4e984661420dbd5393e0b16fe021b0555db2830983d0d4917cf762fe4aa7ac6bbdd5d8681e7
  //     const qrCodeCommand =
  //       '\x1D\x28\x6B' +
  //       String.fromCharCode(base64Url.length + 3, 0) +
  //       '\x31\x50\x30' +
  //       base64Url  +
  //       '\x1D\x28\x6B\x03\x00\x31\x51\x30'; // Comandos para imprimir el QR

  //     // Agregar los comandos para el tamaño del módulo y la alineación
  //     textResponse += '\n';
  //     textResponse += qrAlignCenterCommand + qrModuleSizeCommand + qrCodeCommand;
  //   }

  //   return this.http.post(
  //     url,
  //     { text: textResponse, texto: textResponse, cut: true, cash: true },
  //     options
  //   );
  // }


    guardarVenta (laVenta, datosAdicionales,elaboradosContenido, gestionarSimuladorCuotasExtras: any, cuentasPorCobrarCredito:any = '{}', metodosDePago:any = '{}'){
      let datosGenerales = localStorage.getItem('datosGenerales')
      let datosGeneralesJSON = JSON.parse(datosGenerales)
      let transaccionSegura = false
      if(datosGeneralesJSON && datosGeneralesJSON["transaccionSegura"]) {
        transaccionSegura = datosGeneralesJSON["transaccionSegura"].seleccion === 'S' ? true : false
      }
        const url_servicio = transaccionSegura ? URL_SQS_AWS : URL_SERVICIOS_AWS;
        const rutaUrl =  transaccionSegura ?  'send' : 'procedure'
        let data = {
          name: "almacenarVentaDiariaAFN",
          parameters : {  laVenta: JSON.stringify(laVenta),
            datosAdicionales: JSON.stringify(datosAdicionales),
            elaboradosContenido: elaboradosContenido,
            cuentasPorCobrarSimulador: JSON.stringify(gestionarSimuladorCuotasExtras),
            cuentasPorCobrarCredito: JSON.stringify(cuentasPorCobrarCredito),
            metodosDePago:JSON.stringify(metodosDePago)
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json'})
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/${rutaUrl}`, data, options)
    }

    cancelarProductosElaboradosDinamicos(companiasId:any,productosElaboradosDinamicosId:any,index:any) {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })

      let options = new RequestOptions({
          headers: headers
      })

      const datos = {
          "companiasId": companiasId,
          "productosElaboradosDinamicosId": productosElaboradosDinamicosId,
          "index": index
      }

      return this.http
          .post(`${url}/proceso/cancelarProductosElaboradosDinamicos`, datos, options)

    }

    BuscarProductosElaboradosDinamicosArmarDataAguardar(json:any) {
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "BuscarProductosElaboradosDinamicosArmarDataAguardar",
          parameters : {  "json": json}
        }
        let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http
            .post(`${url_servicio}/procedure`, data, options)
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this.token
        })

        let options = new RequestOptions({
            headers: headers
        })

        const datos = {
            "json": json
         }

        return this.http
            .post(`${url}/proceso/BuscarProductosElaboradosDinamicosArmarDataAguardar`, datos, options)
        }

      }


    imprimirComanda (codigo, companiasId,descripcion){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "imprimirComandas",
          parameters : {   "elRecibo": codigo,
          "companiasId": JSON.stringify(companiasId),
          "descripcion": descripcion}
        }

        let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http
            .post(`${url_servicio}/procedure`, data, options)
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this.token
        })

        let options = new RequestOptions({
            headers: headers
        })

        const datos = {
            "elRecibo": codigo,
            "companiasId": JSON.stringify(companiasId),
            "descripcion": descripcion
        }

        return this.http
            .post(`${url}/proceso/imprimirComandas`, datos, options)
      }
}

imprimirComandasMesas (codigo, companiasId){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMesas",
      parameters : {    "elRecibo": codigo,
      "companiasId": JSON.stringify(companiasId)}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "elRecibo": codigo,
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirComandasMesas`, datos, options)
  }
}

eliminarComandasRegistroIndividualPorCompanias (codigo:any, usuarioIdAutorizo: any, companiasId: any){
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "eliminarComandasRegistroIndividualPorCompanias",
      parameters : {    "comandasId": codigo,
      "usuarioIdAutorizo": usuarioIdAutorizo,
      "companiasId": JSON.stringify(companiasId)}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
}



imprimirComandasMesasPorGestion (codigo, companiasId){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMesasPorGestion",
      parameters : {    "elRecibo": codigo,
      "companiasId": JSON.stringify(companiasId)}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "elRecibo": codigo,
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirComandasMesas`, datos, options)
  }
}


imprimirComandasMesasParcial (datos,codigo, companiasId){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMeseroTurnosParcial",
      parameters : {   "datos": JSON.stringify(datos), "codigo": codigo,
      "companiasId": JSON.stringify(companiasId)}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  }
}

imprimirComandasMesasEmpty ( companiasId: any,automatico?: any){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMesasEmpty",
      // parameters : { "companiasId": JSON.stringify(companiasId)}
      parameters : { "companiasId": companiasId, automatico:automatico}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirComandasMesasEmpty`, datos, options)
  }
}


imprimirComandasMesasEmptyPorGestionAutomatico ( companiasId: any,automatico?: any){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMesasPorGestionAutomatico",
      // parameters : { "companiasId": JSON.stringify(companiasId)}
      parameters : { "companiasId": companiasId, automatico:automatico}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirComandasMesasEmpty`, datos, options)
  }
}

imprimirComandasMesasEmptyPorGestion ( companiasId: any,automatico?: any){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMesasPorGestion",
      // parameters : { "companiasId": JSON.stringify(companiasId)}
      parameters : { "companiasId": companiasId, automatico:automatico}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirComandasMesasEmpty`, datos, options)
  }
}

imprimirComandasMesasEmptyDev ( companiasId){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMesasEmptyDev",
      // parameters : { "companiasId": JSON.stringify(companiasId)}
      parameters : { "companiasId": companiasId}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirComandasMesasEmpty`, datos, options)
  }
}



imprimirFactura (consecutivo, companiasId){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirReciboCaja",
      parameters : {elRecibo: consecutivo, companiasId: JSON.stringify(companiasId)}
    }
    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "elRecibo": consecutivo,
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirReciboCaja`, datos, options)
  }
}



    imprimirComandaBlue(codigo:any,companiasId:any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "imprimirReciboCajaComandas",
          parameters : {elRecibo: codigo, companiasId: companiasId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=imprimirReciboCajaComandas&elRecibo=${codigo}&companiasId=${companiasId}`)
        .map((data) => data.json())
      }
  }

imprimirC() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`sartprintbluetooth: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`)
    .map((data) => data.json())
  }

  imprimirBlueRedirect(data:any) {
    let url = URL_SERVICIOS_LOCALES


    const datos = {
      "nombre": JSON.stringify(data)
      }
      let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })



    return this.http.post(`${url}/blueRedirect`,datos,options)
    .map((data) => data)


  }


    async guardarCajaModoDesconectado(laVenta, datosAdicionales){

      return await this.guardarVentaDesconect(laVenta,datosAdicionales);



    }

    async guardarVentaDesconectOld(laVenta:any, datosAdicionales:any){

        const datos = {
            "laVenta": JSON.stringify(laVenta),
            "datosAdicionales": JSON.stringify(datosAdicionales),
            "RUTA_MODO_DESCONECTADO":RUTA_MODO_DESCONECTADO
        }

       return  this._electronService.ipcRenderer.sendSync('guardar-venta-mododesconectado',datos, (event, data) => {

        });
    }

    async guardarVentaDesconect(laVenta:any, datosAdicionales:any, imprimir: boolean = false){
      try {
        const ipAddress = localStorage.getItem('ipAddress');
        const protocolohttps = localStorage.getItem('protocolohttps');
        const puerto = localStorage.getItem('puerto');
        const url = `${protocolohttps}://${ipAddress}:${puerto}`
        const datos = {
          "laVenta": JSON.stringify(laVenta),
          "datosAdicionales": JSON.stringify(datosAdicionales),
          "RUTA_MODO_DESCONECTADO":RUTA_MODO_DESCONECTADO,
          "imprimir": imprimir
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        const response = await this.http.post(`${url}/guardar-venta-mododesconectado`, {datos},{ headers: headers }).toPromise();
        return response;
      } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
      }
    }

    buscarVentasModoDesconectado(RUTA_MODO_DESCONECTADO:any){


        let result  = this._electronService.ipcRenderer.sendSync('buscar-ventas-modo-desconectado',RUTA_MODO_DESCONECTADO)
        if(result){

                let cuantos = result.length -1
                let dataRealJson =  []
                for(let i =0 ; i<result.length;i++){

                // let resultado = result[i]['nombre']
                let resultado = result[i]
                // var dataReal = JSON.parse(resultado)
                var dataReal = resultado
                let laVenta = dataReal.laVenta

                let datosAdicionales = dataReal.datosAdicionales




                    this.guardarVentaModoDesconectado(laVenta, datosAdicionales).subscribe((data)=>{

                        if(data.status == 200 && i == cuantos){

                            this._electronService.ipcRenderer.sendSync('eliminar-ventas-modo-desconectado',RUTA_MODO_DESCONECTADO)
                        }

                        console.log(data)
                        console.log(i)
                    },(error)=>{


                        console.log(error)
                    })
                  }


            }





    }

    guardarVentaModoDesconectado(laVenta, datosAdicionales){
            let url = URL_SERVICIOS_LOCALES
            let headers = new Headers({
              'Content-Type': 'application/json'
            })
            let options = new RequestOptions({
              headers: headers
            })
            // "laVenta": JSON.stringify(laVenta),
            // "datosAdicionales": JSON.stringify(datosAdicionales),
            let datos: any = {
                "laVenta":JSON.stringify(laVenta),
                "datosAdicionales": JSON.stringify(datosAdicionales),
                "queHago":"G",
                "name":"almacenarVentaDiaria"
              }
            let laVentas = JSON.stringify(laVenta)
            let datosAdicionaless = JSON.stringify(datosAdicionales)
            return this.http.post(`${url}/query`,datos, options)

    }

    guardarVentasdiariasModoDesconectado(laVenta:any, datosAdicionales:any){
        return this.guardarCajaModoDesconectado(laVenta,datosAdicionales)
    }
    guardarComandas (data,codigo){
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this.token
        })

        let options = new RequestOptions({
            headers: headers
        })

        const datos = {
            "datos": JSON.stringify(data),
            "codigo": codigo
            }

        return this.http
            .post(`${url}/proceso/almacenarComandas`, datos, options)
    }

    guardarComandasMesero (data: any,codigo: string,descripcion: string){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        // almacenarComandasMesero
        if (descripcion == undefined) {
          descripcion = ""
        }
        let request = {
          name: "almacenarComandasMeseroTurnos",
          parameters : {
            "datos": JSON.stringify(data),
            "codigo": codigo,
            "descripcion":descripcion
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http
            .post(`${url_servicio}/procedure`, request, options);
      } else {
          let url = URL_SERVICIOS_LOCALES
          let headers = new Headers({
              'Content-Type': 'application/json',
              'authorization': 'Bearer ' + this.token
          })

          let options = new RequestOptions({
              headers: headers
          })

          const datos = {
              "datos": JSON.stringify(data),
              "codigo": codigo,
              "descripcion":descripcion
              }

          return this.http
              .post(`${url}/proceso/almacenarComandasMesero`, datos, options)
      }
    }

    guardarComandasMeseroPorCentroDeCosto (data: any,codigo: string,descripcion: string){
      if(NUBE_AWS) {
        const url_servicio = URL_SERVICIOS_AWS;
        // almacenarComandasMesero
        if (descripcion == undefined) {
          descripcion = ""
        }
        let request = {
          name: "almacenarComandasMeseroTurnosPorCentroDeCosto",
          parameters : {
            "datos": JSON.stringify(data),
            "codigo": codigo,
            "descripcion":descripcion
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http
            .post(`${url_servicio}/procedure`, request, options);
      } else {
          let url = URL_SERVICIOS_LOCALES
          let headers = new Headers({
              'Content-Type': 'application/json',
              'authorization': 'Bearer ' + this.token
          })

          let options = new RequestOptions({
              headers: headers
          })

          const datos = {
              "datos": JSON.stringify(data),
              "codigo": codigo,
              "descripcion":descripcion
              }

          return this.http
              .post(`${url}/proceso/almacenarComandasMesero`, datos, options)
      }
    }



    buscarComandas(codigo:any,companiasId:any,estado:string) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarComandas",
          parameters : {companiasId: companiasId, mesa: codigo}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/query?name=buscarComandas&mesa=${codigo}&companiasId=${companiasId}&estado=${estado}`)
          .map((data) => data.json())
      }
     }

      buscarComandasMesero(codigo:any,companiasId:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarComandasMesero",
            parameters : {companiasId: companiasId, mesa: codigo}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/query?name=buscarComandasMesero&mesa=${codigo}&companiasId=${companiasId}`)
          .map((data) => data.json())
       }
      }


      buscarComandasDomicilio(codigo:any,companiasId:any,estado:string) {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarComandasDomicilios&codigo=${codigo}&companiasId=${companiasId}&estado=${estado}`)
        .map((data) => data.json())
      }

      ActualizarColorComandasDomicilio(codigo:any,companiasId:any,color:any) {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=ActualizarColorComandasDomicilio&codigo=${codigo}&companiasId=${companiasId}&color=${color}`)
        .map((data) => data.json())
      }


      buscarComandasPorId(id:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarComandasPorId",
            parameters : {id: id}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarComandasPorId&id=${id}`)
        .map((data) => data.json())
        }
      }

      buscarComandasFactura(codigo:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarComandasFactura",
            parameters : {codigo: codigo}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarComandasFactura&codigo=${codigo}`)
        .map((data) => data.json())
        }
      }

      buscarComandasFacturaPorCompania(codigo:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarComandasFacturaPorCompania",
            parameters : {codigo: codigo, companiasId: this.companiaId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarComandasFacturaPorCompania&codigo=${codigo}&companiasId=${this.companiaId}`)
        .map((data) => data.json())
        }
      }


      buscarComandasFacturaPorCompaniaDividirCuenta(codigo:any,companiasId?:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarComandasFacturaPorCompania",
            parameters : {codigo: codigo, companiasId: this.companiaId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarComandasFacturaPorCompania&codigo=${codigo}&companiasId=${this.companiaId}`)
        .map((data) => data.json())
        }
      }




      buscarComandasDomicilios() {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarComandasDomicilios",
            parameters : {}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarComandasDomicilios`)
        .map((data) => data.json())
        }
      }

      // buscarParametrosGenerales(companiaId:any) {
      //     let url_servicio = URL_SERVICIOS_AWS;
      //     let data = {
      //       name: "BuscarparametrosGenerales",
      //       parameters : {companiaId: companiaId, usuariosId: this.usuarioId}
      //     }

      //     let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      //     let options = new RequestOptions({ headers: headers }) // Create a request option
      //     return this.http.post(`${url_servicio}/procedure`, data, options);
      // }
      buscarParametrosGenerales(companiasId: any) {
        if (this.cachedData) {
            // Si los datos están en caché, devolver un observable directamente PUSH
            return new Observable(observer => {
                observer.next(this.cachedData);
                observer.complete();
            });
        } else {
            let url_servicio = URL_SERVICIOS_AWS;
            let data = {
                name: "BuscarparametrosGenerales",
                parameters: { companiaId: companiasId, usuariosId: this.usuarioId }
            }
            let headers = new Headers({ 'Content-Type': 'application/json' });
            let options = new RequestOptions({ headers: headers });

            return this.http.post(`${url_servicio}/procedure`, data, options).pipe(
                map((response) => {
                    // Guardar el resultado en caché
                    this.cachedData = response;
                    return response;
                })
            );
        }
    }

      buscarParametrosGeneralesPedidosSalonRedux(companiaId:any, usuariosId:any) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "buscarparametrosGeneralesPedidosSalon",
            parameters : {companiaId: companiaId, usuariosId: usuariosId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
      }

      actualizarComandas(comanda: any) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: comanda.name,
            parameters : {...comanda}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
      }

      ActualizarComandasPorTurno(companiasId: any,turno: any,consecutivo: any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "ActualizarComandasPorTurno",
            parameters : {companiasId: companiasId, turno: turno, consecutivo:consecutivo}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        }
      }



      actualizarSeguimientoReserva(companiasId: any,comandasId:any,consecutivo:any = "") {

          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "actualizarSeguimientoReserva",
            parameters : {companiasId: companiasId, comandasId: comandasId, consecutivo:consecutivo}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
      }

      genearNotificacionComandas(titulo,mensaje) {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/notificacion?titulo=${titulo}&mensaje=${mensaje}`)
            .map((data) => data.json())
    }

    cancelarComandas(item: any) {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })

        return this.http.get(`${url}/query?name=cancelarComandas&codigo=${item.comandasId}`, options)
      }

      cancelarComandasPorCompanias(item: any,companiasId:any) {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })

        return this.http.get(`${url}/query?name=cancelarComandasPorCompanias&codigo=${item.comandasId}&companiasId=${companiasId}`, options)
      }

      eliminarComandasPorCompanias(codigo: any,companiasId:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: 'eliminarComandasPorCompanias',
            parameters : {codigo: codigo, companiasId: companiasId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })

        return this.http.get(`${url}/query?name=eliminarComandasPorCompanias&codigo=${codigo}&companiasId=${companiasId}`, options)
        }
      }

      buscarFactura(val:any) {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
            'Content-Type': 'application/json',

        })
        let options = new RequestOptions({
          headers: headers
        })

          return this.http.get(`${url}/query?name=reemprimirFacturas&companiasId=${val}`, options)
      }

      buscarFacturaCuentaPorCobrar(elRecibo:any,val:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "imprimirReciboCaja",
            parameters : {elRecibo: elRecibo, companiasId:val}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
          let url = URL_SERVICIOS_LOCALES
          let headers = new Headers({
              'Content-Type': 'application/json',

          })
          let options = new RequestOptions({
            headers: headers
          })

            return this.http.get(`${url}/query?name=imprimirReciboCaja&elRecibo=${elRecibo}&companiasId=${val}`, options)

        }
      }

      buscarVentasDiarias(elRecibo:any,val:any){
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "imprimirReciboCaja",
            parameters : {elRecibo: elRecibo, companiasId:val}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/query?name=imprimirReciboCaja&elRecibo=${elRecibo}&companiasId=${val}`)
            .map((data) => data.json())
        }
      }

      buscarVentasDiariasTendero(elRecibo:any,val:any){
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "imprimirReciboCajaTendero",
            parameters : {elRecibo: elRecibo, companiasId:val}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/query?name=imprimirReciboCaja&elRecibo=${elRecibo}&companiasId=${val}`)
            .map((data) => data.json())
        }
      }

      devolverVenta(val:any,consecutivo:any){
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "devolverVenta",
            parameters : {companiasId: val, consecutivo: consecutivo}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/query?name=devolverVenta&companiasId=${val}&consecutivo=${consecutivo}`)
        }
      }

      devolverVentaHistorico(val:any,consecutivo:any,fechaVenta:string){
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "devolverVentaHistorico",
            parameters : {companiasId: val, consecutivo: consecutivo,fecha:fechaVenta}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
          let url = URL_SERVICIOS_LOCALES
          return this.http.get(`${url}/query?name=devolverVenta&companiasId=${val}&consecutivo=${consecutivo}`)
        }
      }

      devolverCuentaPorCobrar(elPagoDevuelve:any){
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "devolverAbonoCuentaPorCobrar",
            parameters : {elPagoDevuelve: JSON.stringify(elPagoDevuelve)}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);

      }

    buscarCuentaPorCobrar (data){
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let valores = {
          name: "buscarCuentasPorCobrarConSaldo",
          parameters : {jsonFiltros:JSON.stringify(data)}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, valores, options);
      } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "jsonFiltros": JSON.stringify(data)
        }

    return this.http
        .post(`${url}/proceso/buscarCuentasPorCobrarConSaldo`, datos, options)
      }
}


async buscarCuentaPorCobrarAsync(data) {
  try {
    let response;
    if (NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;
      const valores = {
        name: "buscarCuentasPorCobrarConSaldo",
        parameters: { jsonFiltros: JSON.stringify(data) }
      };
      const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
      const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

      response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
    } else {
      const url = URL_SERVICIOS_LOCALES;
      const headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
      });
      const options = new RequestOptions({ headers: headers });

      const datos = {
        jsonFiltros: JSON.stringify(data)
      };

      response = await this.http.post(`${url}/proceso/buscarCuentasPorCobrarConSaldo`, datos, options).toPromise();
    }

    // Aquí puedes manejar la respuesta
    return response;
  } catch (error) {
    // Manejo de errores
    console.error('Error en buscarCuentaPorCobrar:', error);
    throw error;
  }
}

async calcularValoresCuentaPorCobrarAsync(companiasId:any,cuentasPorCobrarId:any=0,fechaCalcula:any='1900-01-01') {
try {
  let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "calcularValoresCuentaPorCobrar",
      parameters : {companiasId:companiasId,
        cuentasPorCobrarId:cuentasPorCobrarId,
        fechaCalcula:fechaCalcula,
        esUnPago:'N'
      }
    }

    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options).toPromise();

} catch (error) {
    // Manejo de errores
    console.error('Error en buscarCuentaPorCobrar:', error);
    throw error;
  }
}


buscarCuentaPorCobrarValorTotal(companiasId: any,clientesId:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarCuentaPorCobrarValorTotal",
      parameters : {companiasId:companiasId,clientesId:clientesId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })

    return this.http.get(`${url}/query?name=buscarCuentaPorCobrarValorTotal&companiasId=${companiasId}&clientesId=${clientesId}`, options)
  }
}

  buscarCuentaPorCobrarValorTotalPorFecha(companiasId: any,fecha:any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })
    return this.http.get(`${url}/query?name=buscarCuentaPorCobrarValorTotalPorFecha&companiasId=${companiasId}&fecha=${fecha}`, options)
  }


  buscarEgresosIngresosValorTotal(companiasId: any,fecha:any, usuarioId: any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarEgresosDiariosCompaniaTotales",
        parameters : {companiasId:companiasId,fechaInforme:fecha, usuarioId:usuarioId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);

  }

  buscarPropinas(fecha:any, companiasId: any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarSeguimientoServicios",
      parameters : {fechaInforme:fecha,companiasId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);

}




  almacenarPagoCuentaPorCobrar (data){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let valores = {
        name: "almacenarPagoCuentaPorCobrar",
        parameters : {
          "elPago":JSON.stringify(data)
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, valores, options);
    } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "elPago": JSON.stringify(data)
        }

    return this.http
        .post(`${url}/proceso/almacenarPagoCuentaPorCobrar`, datos, options)
  }
}

validarAlmacenarPagoCuentaPorCobrar (data:string){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let valores = {
      name: "validarAlmacenarPagoCuentaPorCobrar",
      parameters : {
        "comprobantePago":data
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option

    return this.http.post(`${url_servicio}/procedure`, valores, options);
  } else {
  let url = URL_SERVICIOS_LOCALES
  let headers = new Headers({
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + this.token
  })

  let options = new RequestOptions({
      headers: headers
  })

  const datos = {
      "elPago": JSON.stringify(data)
      }

  return this.http
      .post(`${url}/proceso/almacenarPagoCuentaPorCobrar`, datos, options)
}
}


validarAlmacenarPagoCuentaPorCobrarPorCompania(data:string,companiasId:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let valores = {
      name: "validarAlmacenarPagoCuentaPorCobrar",
      parameters : {
        "comprobantePago":data,
        "companiasId": companiasId
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option

    return this.http.post(`${url_servicio}/procedure`, valores, options);
  } else {
  let url = URL_SERVICIOS_LOCALES
  let headers = new Headers({
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + this.token
  })

  let options = new RequestOptions({
      headers: headers
  })

  const datos = {
      "elPago": JSON.stringify(data)
      }

  return this.http
      .post(`${url}/proceso/almacenarPagoCuentaPorCobrar`, datos, options)
}
}

buscarinformePorFechas(valor:any,companiasId:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "informeDeVentasDiariasPorCostos",
      parameters : {
      "fechaInforme":valor,
      "companiasId":companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',

    })
    let options = new RequestOptions({
      headers: headers
    })

      return this.http.get(`${url}/query?name=informeDeVentasDiariasPorCostos&fechaInforme=${valor}&companiasId=${companiasId}`, options)
  }
}

  buscarinformeLocal(data:any,nombre:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: "VentasDiariasPorCostos",
        parameters : {
          "data": JSON.stringify(data),
          "nombre":"VentasDiariasPorCostos"}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',

    })
    let options = new RequestOptions({
      headers: headers
    })
    const datos = {
        "data": JSON.stringify(data),
        "nombre":"VentasDiariasPorCostos"
        }
        let data2 = JSON.stringify(data)


    this.http.post(`${url}/informes`,datos,options)
    .subscribe((data)=>{

    },(error)=>{

    })

    this.storage.set('imprimirArchivo','VentasDiariasPorCostos')
  }
  }



  buscarVentasdiariasCaja (id:any, ultimoRegistro: any = 0){
    const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
    if(NUBE_AWS) {
      let data = {
        name: "buscarVentasdiariasCaja",
        parameters : {companiasId: id,
          ultimoRegistro:ultimoRegistro
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options)
    } else {
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })

      let options = new RequestOptions({
          headers: headers
      })

      const datos = {
          "companiasId":id
          }

      return this.http
          .post(`${url}/proceso/buscarVentasdiariasCaja`, datos, options)
    }



}


buscarVentasdiariasCajaPrincipal (id:any, ultimoRegistro: any = 0){
  const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
  if(NUBE_AWS) {
    let data = {
      name: "buscarVentasdiariasCajaPrincipal",
      parameters : {companiasId: id,
        ultimoRegistro:ultimoRegistro
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url}/procedure`, data, options)
  } else {
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId":id
        }

    return this.http
        .post(`${url}/proceso/buscarVentasdiariasCaja`, datos, options)
  }



}

guardarProductosDesconectado(result,nombreProcedimiento){


    let cuantos = result.length -1

    let dataRealJson =  []

    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

        let nuevaData = result.filter(e => e.actualizado.indexOf('S') != -1)
        if(nuevaData.length >0){
            let datos:any = {
                "datos":JSON.stringify(nuevaData)
            }

            return this.http.post(`${url}/procesos/${nombreProcedimiento}`,datos,options)
        }else{
            let datos:any = {
                "datos":''
            }

            return this.http.post(`${url}/procesos/respuestaDesconectado`,datos)
        }
}

sincronizarDatosSubidosModoDesconectado(companiasId:any,fechaSincroniza:any){

    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    let datos:any = {
        "companiasId":companiasId,
        fechaSincroniza:fechaSincroniza
    }
     return this.http.post(`${url}/procesos/sincronizarDatosSubidosModoDesconectado`,datos,options)

}

guardarVentasDiariasDesconectado(jsonLaVenta:any,jsonDatosAdicionales:any){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "guardarVentasDiariasDesconectado",
      parameters : {   "jsonLaVenta":jsonLaVenta,
      "jsonDatosAdicionales":jsonDatosAdicionales}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    let datos:any = {
        "jsonLaVenta":jsonLaVenta,
        "jsonDatosAdicionales":jsonDatosAdicionales
    }
     return this.http.post(`${url}/procesos/guardarVentasDiariasDesconectado`,datos,options)
  }
}

ventasDiariasSinSincronizar(data:any){
  if(!NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "guardarVentasDiariasDesconectado",
      parameters : { "datos":JSON.stringify(data)}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    let datos:any = {
        "datos":JSON.stringify(data)
    }

     return this.http.post(`${url}/procesos/guardarVentasDiariasDesconectado`,datos,options)
  }
}


buscarModoDesconectados(valores:any){
  for(let i =0;i < valores.length;i++){
      let nombre = JSON.stringify(valores[i].nombre)
      let ruta = JSON.stringify(valores[i].ruta)
      let nombreProcedimiento = JSON.stringify(valores[i].nombreProcedimiento)

      let RUTA_MODO_DESCONECTADO_LIMPIA = ruta.replace(/"/g, '');
      let nombreRutaLimpio = nombre.replace(/"/g, '');
      let nuevaruta = `${RUTA_MODO_DESCONECTADO_LIMPIA}${nombreRutaLimpio}\\`
      let valoresReales = [{'nombre':nombre,'ruta':ruta, 'nuevaruta':nuevaruta}]
      let result:any

      result  = this._electronService.ipcRenderer.sendSync('buscar-modo-desconectado',valoresReales)
      if(result){
        let cuantos = result.length -1

          if(cuantos !== -1){
            // Combina todos los subarrays en uno solo
            let flatResult = result.reduce((acc, arr) => acc.concat(arr), []);

            // Filtra los objetos con actualizado: 'S'
            let nuevaData = flatResult.filter(obj => obj.actualizado === 'S');
            //let nuevaData = result.filter(e => e.actualizado.indexOf('S') != -1)
            if(nuevaData.length ==0){
                return false
            }
            let url_servicio = URL_SERVICIOS_AWS;
            let values = {
              name: nombreProcedimiento,
              parameters : { "datos":JSON.stringify(nuevaData)}
            }
            let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
            let options = new RequestOptions({ headers: headers }) // Create a request option
            return this.http.post(`${url_servicio}/procedure`, values, options);

          }
    }
  }
}

trasladarMesaPorCompania(mesaActual:any,mesaNueva:any,companiasId:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "trasladarMesaPorCompania",
      parameters : {companiasId:companiasId,mesaActual:mesaActual,mesaNueva:mesaNueva}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=trasladarMesaPorCompania&mesaActual=${mesaActual}&mesaNueva=${mesaNueva}&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  guardarVentaDesconectUnica(laVenta:any, datosAdicionales:any){

    const datos = {
        "laVenta": JSON.stringify(laVenta),
        "datosAdicionales": JSON.stringify(datosAdicionales),
        "RUTA_MODO_DESCONECTADO":RUTA_MODO_DESCONECTADO
    }

   return  this._electronService.ipcRenderer.sendSync('afnafn-mododesconectado',datos, (event, data) => {

    });
  }

  abrirPagina(nombre:string){
    let promise = new Promise((resolve,reject)=> {
     this.store.select('rutas')
     .subscribe((item) => {
         let data = 0
         const datos = item.rutas === null ? [] : JSON.parse(item.rutas["nombre"]);
         for(var i=0;i < datos.length;i++){
           if(datos[i].nombre == nombre){
             data = -1
             return resolve(true);
           }
         }
         return resolve(false);
     }, (error ) => {
       console.log(error);
       return reject(false);
     });
    })

    return promise
   }

  guardarTodo(data: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: "dataDynamicCrud",
        parameters : {...data, nombreTabla: "productos"}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
        const url = URL_SERVICIOS_LOCALES;
        return this.http.post(`${url}/query`, data);
     }
  }

  buscarGruposCompaniasId(companiasId: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: "buscargruposProductos",
        parameters : {companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
      const url = URL_SERVICIOS_LOCALES;
      const datos = {
          companiasId
      };
      return this.http.post(`${url}/procesos/buscargruposProductos`, datos);
     }
  }

  buscarClientesAll(companiasId: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: "buscarClientesPorCompaniaAll",
        parameters : {companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
    const url = URL_SERVICIOS_LOCALES;
    const datos = {
        companiasId
    };
    return this.http.post(`${url}/procesos/buscarClientesPorCompaniaAll`, datos);
  }
 }

 trasladarMesaPorCompaniaDomicilios(mesaActual: any, mesaNueva: any, companiasId: any, turno: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "trasladarMesaPorCompaniaDomicilios",
      parameters : {      mesaActual,
        mesaNueva,
        companiasId,
        turno}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
  const url = URL_SERVICIOS_LOCALES;
  const datos: any = {
      mesaActual,
      mesaNueva,
      companiasId,
      turno
  };
  return this.http.post(`${url}/procesos/trasladarMesaPorCompaniaDomicilios`, datos);
 }
}

buscarComandasturnoPorCompania(turno: any, companiasId: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "buscarComandasturnoPorCompania",
      parameters : { turno,companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
  const url = URL_SERVICIOS_LOCALES;
  return this.http.get(`${url}/query?name=buscarComandasturnoPorCompania&turno=
                        ${turno}&companiasId=${companiasId}`);
 }
}
getComandasVacio(companiasId: any, usuariosId: any, clientesId: any, descripcion: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "BuscarTurnosAppComandasVacio",
      parameters : { companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
  const url = URL_SERVICIOS_LOCALES;
  const datos: any = {
      companiasId
  };
  return this.http.post(`${url}/procesos/BuscarTurnosAppComandasVacio`, datos);
 }
}

buscarUsuarioPorEmpresaDomicilios(companiasId: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "buscarUsuarioPorEmpresaDomicilios",
      parameters : { companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
  const url = URL_SERVICIOS_LOCALES;
  const datos = {
      companiasId
  };
  return this.http.post(`${url}/procesos/buscarUsuarioPorEmpresaDomicilios`, datos);
 }
}

imprimirComandaBlueafn(codigo: any, companiasId: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "imprimirReciboCajaComandas",
      parameters : {  elRecibo: codigo,
        companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
  const datos = {
      elRecibo: codigo,
      companiasId
    };
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })
  return this.http
      .post(`${url}/procesosafn/imprimirReciboCajaComandas`, datos, {headers});
  }
}

buscarComandasturnoPorCompaniaAsignados(companiasId: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "buscarComandasturnoPorCompaniaAsignados",
      parameters : {  companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
  const url = URL_SERVICIOS_LOCALES;
  return this.http.get(`${url}/query?name=buscarComandasturnoPorCompaniaAsignados&companiasId=${companiasId}`);
 }
}

buscarDomiciliosPorCompania(companiasId: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "buscarDomiciliosPorCompania",
      parameters : {  companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);
  } else {
  const url = URL_SERVICIOS_LOCALES;
  const datos = {
      companiasId
  };
  return this.http.post(`${url}/procesos/buscarDomiciliosPorCompania`, datos);
}
}

devolverAbono(id:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarComandasPorId",
      parameters : {id: id}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
  let url = URL_SERVICIOS_LOCALES
  return this.http.get(`${url}/query?name=buscarComandasPorId&id=${id}`)
  .map((data) => data.json())
  }
}
actualizarClienteFactura(companiasId:any,clienteId:any,consecutivo:any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "actualizarclientefactura",
      parameters : {companiasId: companiasId, clientesId:clienteId,consecutivo: consecutivo}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}
    actualizarReservasPorTurno(companiasId: any,turno: any,consecutivo: any) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "actualizarReservasPorTurno",
            parameters : {companiasId: companiasId, turno: turno, consecutivo:consecutivo}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
      }


      async getComandasVacioAsync(companiasId: any, usuariosId: any, clientesId: any, descripcion: any) {
       try {
          if(NUBE_AWS) {
            let url_servicio = URL_SERVICIOS_AWS;
            let values = {
              name: "BuscarTurnosAppComandasVacio",
              parameters : { companiasId}
            }
            let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
            let options = new RequestOptions({ headers: headers }) // Create a request option
            let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
            return response
          } else {
          const url = URL_SERVICIOS_LOCALES;
          const datos: any = {
              companiasId
          };
          return this.http.post(`${url}/procesos/BuscarTurnosAppComandasVacio`, datos);
        }
      } catch (error) {
        console.error('Error al guardar la placa:', error);
        throw error;
      }
    }

    imprimirReciboCajaComandasParqueaderosPorGestion(turno:any,companiaId:any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "imprimirReciboCajaComandasParqueaderosPorGestion",
        parameters : {turno: turno,companiasId: companiaId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  ventasDiariasParaSincronizar(datos:any,companiasId:any){
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: "guardarVentasDiariasSinCerrarDesconectado",
        parameters : {datos:  JSON.stringify(datos),
          companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);

  }

  sincronizarVentasModoDesconectadoCompania(companiasId:any){
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "sincronizarVentasModoDesconectadoCompania",
      parameters : {
        companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, values, options);

}

buscarIntereses(companiasId:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarInteresesCreditos",
      parameters : {companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

buscarPlanDePagosConIntereses(cuentasPorCobrarId:any,companiasId:any=0) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarPlanDePagosConIntereses",
    parameters : {cuentasPorCobrarId:cuentasPorCobrarId,companiasId: companiasId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

consultarPlanDePagosCuentaPorCobrar(cuentasPorCobrarId:any,companiasId:any=0) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "consultarPlanDePagosCuentaPorCobrar",
    parameters : {cuentaPorCobrarId:cuentasPorCobrarId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

calcularValoresCuentaPorCobrar(companiasId:any,cuentasPorCobrarId:any=0,fechaCalcula:any='1900-01-01') {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "calcularValoresCuentaPorCobrar",
    parameters : {companiasId:companiasId,
      cuentasPorCobrarId:cuentasPorCobrarId,
      fechaCalcula:fechaCalcula,
      esUnPago:'N'
    }
  }

  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}


imprimirComandasMesasPorGestionMultiplesImpresoras (codigo, companiasId){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirComandasMesasPorGestionMultiplesImpresoras",
      parameters : {    "elRecibo": codigo,
      "companiasId": JSON.stringify(companiasId)}
    }

    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http
        .post(`${url_servicio}/procedure`, data, options)
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "elRecibo": codigo,
        "companiasId": JSON.stringify(companiasId)
    }

    return this.http
        .post(`${url}/proceso/imprimirComandasMesas`, datos, options)
  }
}
imprimirComandaBlueRed(codigo:any,companiasId:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirReciboCajaComandas",
      parameters : {elRecibo: codigo, companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=imprimirReciboCajaComandas&elRecibo=${codigo}&companiasId=${companiasId}`)
    .map((data) => data.json())
  }
}

buscarVentasDiariasCufe(elRecibo:any,val:any){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "imprimirReciboCajaElectronico",
      parameters : {elRecibo: elRecibo, companiasId:val}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=imprimirReciboCaja&elRecibo=${elRecibo}&companiasId=${val}`)
      .map((data) => data.json())
  }
}


convertirBase64ABytes(base64: string): Uint8Array {
  const binaryString = atob(base64.split(',')[1]);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}


convertirImagenBase64(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
      const reader = new FileReader();
      reader.onloadend = function () {
        resolve(reader.result as string);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.onerror = function () {
      reject(new Error('Error al cargar la imagen'));
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  });
}

buscarProductoPorEmpresaPaginado(companiasId:any,pagina:any,cantidadPaginar:any){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarProductoPorEmpresaPaginado",
      parameters : {companiasId:companiasId,pagina:pagina,cantidadPaginar:cantidadPaginar}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
    .map((data) => data.json())
 }
}


async buscarResumenPorCliente(companiasId:any,clientesId:any) {
  try {
    let response;
     const url_servicio = URL_SERVICIOS_AWS;
      const valores = {
        name: "buscarResumenPorCliente",
        parameters: { companiasId, clientesId }
      };
      const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
      const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

      response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
      return response
  } catch (error) {
    // Manejo de errores
    console.error('Error en buscarCuentaPorCobrar:', error);
    throw error;
  }
}

async buscarProductosCamposAdicionalesCambiarNombre(companiasId:any) {
  try {
    let response;
     const url_servicio = URL_SERVICIOS_AWS;
      const valores = {
        name: "buscarProductosCamposAdicionalesCambiarNombre",
        parameters: { companiasId }
      };
      const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
      const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

      response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
      return response
  } catch (error) {
    console.error('Error en buscarCuentaPorCobrar:', error);
    throw error;
  }
}


async buscarFormasDePago(companiasId:any) {
  try {
    let response;
     const url_servicio = URL_SERVICIOS_AWS;
      const valores = {
        name: "buscarFormasDePago",
        parameters: { companiasId }
      };
      const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
      const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

      response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
      return response
  } catch (error) {
    console.error('Error en buscarFormasDePago:', error);
    throw error;
  }
}

buscarClientesUltimoRegistro (text){
  if(NUBE_AWS) {
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarClientesUltimoRegistro",
      parameters : {companiasId: text}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option

    return this.http.post(`${url_servicio}/procedure`, data, options)
        .map((data: any) =>
         {
           let  dataNew = JSON.parse(data._body).data
           return dataNew[0].map((item, index) => {
              return {
                display: item.nombreCliente,
                value: item.clientesId
            }})});
  } else {
    const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarClientesPorCompaniaAll?companiasId=${this.companiaId}`;
    return this.http
        .get(url)
        .map(data => data.json()[0].map(item => {
            return {
                display: item.nombreCliente,
                value: item.clientesId
            }
        } ));
  }
}

buscarComandasFacturaPorCompaniaFormasDePago(codigo:any,companiasId:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarComandasFacturaPorCompania",
      parameters : {codigo: codigo, companiasId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
  let url = URL_SERVICIOS_LOCALES
  return this.http.get(`${url}/query?name=buscarComandasFacturaPorCompania&codigo=${codigo}&companiasId=${this.companiaId}`)
  .map((data) => data.json())
  }
}

async buscarDescripcionCliente(companiasId:any,clientesId:any) {
  try {
    let response;
     const url_servicio = URL_SERVICIOS_AWS;
      const valores = {
        name: "buscarDescripcionCliente",
        parameters: { companiasId, clientesId }
      };
      const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
      const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

      response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
      return response
  } catch (error) {
    // Manejo de errores
    console.error('Error en buscarCuentaPorCobrar:', error);
    throw error;
  }
}


async pagarMesas(
  listaProductos: any[] = [],
  listaFormasDePago: any[] = [],
  valorTotalDevolver: any = 0,
  valorPagado: any = 0,
  formasDePagoGeneral: any[] = [],
  price: string = '',
  formaPagoSeleccionada: string = '',
  CheckPorcentajeServicio: boolean = false,
  turnosArray:any,
  listaProductosSeleccionados:any,
  mesaSeleccionada:any,
  deseaImprimir:boolean = false,
  devolver:any=0,
  datosAdicionales:any,
  valorDescuento:Number =0,
  valorDeLaPropina:any
) {
  if (formasDePagoGeneral.length > 0) {
    datosAdicionales['formasDePago'] = JSON.stringify(formasDePagoGeneral);

    let valorPago = '';

    if (typeof price === 'string') {
      // Remover comas
      if (price.includes(',')) {
        valorPago = price.replace(/,/g, '');
      } else {
        valorPago = price;
      }

      // Validar que solo haya un punto decimal
      const puntoDecimal = (valorPago.match(/\./g) || []).length;
      if (puntoDecimal > 1) {
        console.log('El formato del número es inválido.');
      } else {
        // Convertir a número si el formato es válido
        let valorNumerico = parseFloat(valorPago);
        console.log('Valor numérico:', valorNumerico);
      }
    } else {
      valorPago = price
    }

    valorTotalDevolver = 0;
    // datosAdicionales.valorTotalVenta = Number(valorPago);
  }

  if (listaProductos.length > 0) {
    if (listaFormasDePago.length > 0) {
      valorTotalDevolver = Number(valorTotalDevolver) - Number(valorPagado);
      // datosAdicionales.valorTotalVenta = Number(valorPagado);
      datosAdicionales['formasDePago'] = JSON.stringify(listaFormasDePago);
    }
  }

  // datosAdicionales['totalPagado'] = valorPagado > 0 ? valorPagado : valorTotalDevolver;
  let valorTotalVentaValidar: number =
    valorTotalDevolver > 0 ? valorTotalDevolver : Number(valorTotalDevolver) - valorPagado > 0 ? valorPagado : Number(datosAdicionales.valorTotalVenta);

  if (valorTotalVentaValidar < 0) {
    this.utils.mensajeMuestro('Pagar ventas', 'Valor a devolver no valido!', 'warning');
    return;
  } else if (datosAdicionales.valorTotalVenta < 0) {
    this.utils.mensajeMuestro('Pagar ventas', 'Valor venta no valido!', 'warning');
    return;
  }

  // datosAdicionales['valorTotalDevolver'] = valorTotalVentaValidar - valorPagado > 0 ? valorPagado : 0;
  // datosAdicionales['valorTotalVenta'] = valorPagado > 0 ? valorPagado : datosAdicionales.valorTotalVenta;

  try {
    const res: any = await this.getMultiple(['usuariosId', 'companiasId']);

    let valoresListaProductosSeleccionados = listaProductos[0];
    const codigo = valoresListaProductosSeleccionados['codigo'];
    const clienteCaja: any = await this.buscarClienteStore();

    if (
      clienteCaja['valuedisplay'] !== undefined &&
      clienteCaja['valuedisplay'][0] !== undefined &&
      clienteCaja['valuedisplay'][0].value !== undefined
    ) {
      datosAdicionales['clientesId'] = clienteCaja['valuedisplay'][0].value;
    }

    if (!CheckPorcentajeServicio && datosAdicionales['clientesId'] == 0) {
      datosAdicionales['clientesId'] = 3;
    }

    if (datosAdicionales['clientesId'] == 0 && formaPagoSeleccionada == 'C') {
      console.log('Para generar una cuenta por cobrar debe asignar un cliente', 'Advertencia');
      return;
    }

    datosAdicionales['tipoVenta'] = formaPagoSeleccionada;
    datosAdicionales['servicio'] = listaProductos[0].incluirServicio == 'S' ? listaProductos[0].incluirServicio : 'N';

    datosAdicionales['usuariosId'] = res['usuariosId'];
    datosAdicionales['companiasId'] = res['companiasId'];

    if (datosAdicionales['usuariosId'] == null) {
      datosAdicionales['usuariosId'] = 3;
    }

      if (codigo !== undefined) {
          if(formasDePagoGeneral && formasDePagoGeneral.length>0) {
            formasDePagoGeneral = formasDePagoGeneral[0] !== undefined ? formasDePagoGeneral[0] : formasDePagoGeneral[1]
            formasDePagoGeneral = formasDePagoGeneral.map((forma :any)=> ({
                persona: forma.persona,
                codigoFormaPago: forma.codigoFormaPago,
                formaPago: forma.nombreFormaPago, // renombrar nombreFormaPago a formaPago
                imagen: forma.imagen,
                valorFormaPago: forma.valor, // renombrar valor a valorFormaPago
                formattedValor: forma.formattedValor
              }))
          this.generarVenta(listaProductos,turnosArray,listaProductos,formasDePagoGeneral,mesaSeleccionada,deseaImprimir,devolver,datosAdicionales,valorDescuento,valorDeLaPropina);
        } else {
          this.generarVenta([], turnosArray,listaProductos,formasDePagoGeneral,mesaSeleccionada,deseaImprimir,devolver,datosAdicionales,valorDescuento,valorDeLaPropina);
        }
      } else {
        this.generarVentaSinGestion(listaProductos,datosAdicionales,turnosArray,deseaImprimir,valorDescuento,valorDeLaPropina);
        return
      }
  } catch (error) {
    console.error(error);
  }
}


getMultiple(keys: string[]) {
  const promises:any = [];

  keys.forEach( key => promises.push(this.storage.get(key)) );

  return Promise.all(promises).then( values => {
    const result:any = {};

    values.map( (value, index) => {
      result[keys[index]] = value;
    });

    return result;
  });
}


async buscarClienteStore() {
  return new Promise((resolve, reject) => {
     this.storePedidosSalon.select('clienteSelect').subscribe((clientecaja) => {
       return resolve(clientecaja)
     })
   });
 }

 async generarVenta(listaProductos:any =  [],turnosArray:any, listaProductosSeleccionados:any,formasDePagoGeneral:any,mesaSeleccionada:any,deseaImprimir:any,
  devolver:any=0,
  datosAdicionales:any,
  valorDescuento:any=0,
  valorDeLaPropina:any
 ) {
  let listaProductosSeleccionadosNuevosValores = this.refactorizarValoresMesas(listaProductosSeleccionados)
  let fechaVenta = this.fechaVenta
  if(fechaVenta!=undefined && fechaVenta !== null){
    datosAdicionales['fechaVenta'] = fechaVenta
  }
  let elaboradosContenido:any = ''
  let turno:any = undefined
  let comandasId:any = undefined
  if(datosAdicionales.turno != undefined && datosAdicionales.turno > 0) {
    turno = datosAdicionales.turno
    comandasId = datosAdicionales.comandasId
  }

  if(datosAdicionales['turno'] == 0) {
    datosAdicionales['turno'] = turnosArray[0].turno
  }
  if(datosAdicionales.turno != undefined && datosAdicionales.turno > 0) {
    turno = datosAdicionales.turno
    comandasId = datosAdicionales.comandasId
  }
  if(comandasId == undefined){
    let cuantosLista = listaProductosSeleccionadosNuevosValores.length - 1
    comandasId = listaProductosSeleccionadosNuevosValores[cuantosLista].comandasId
    datosAdicionales['fechaVenta'] = listaProductosSeleccionadosNuevosValores[cuantosLista].fecha
    datosAdicionales['comandasId'] =comandasId
    datosAdicionales['turno'] =listaProductosSeleccionadosNuevosValores[cuantosLista].turno
  }
  datosAdicionales['codigo'] = listaProductosSeleccionadosNuevosValores[0].codigo
  let usuarioIngreso = this.usuarioId;
  let usuarioId = usuarioIngreso;
  if(usuarioId) {
    datosAdicionales['usuariosId'] = usuarioId
  }
    // if(listaProductos.length>0 || formasDePagoGeneral.length>0){
    //   datosAdicionales['totalPagado'] = datosAdicionales['valorTotalDevolver']
    //   datosAdicionales['valorTotalDevolver'] = datosAdicionales['valorTotalDevolver'] -   datosAdicionales['totalPagado']
    // }
    // if(datosAdicionales && datosAdicionales.totalPagado == undefined &&
    //   formasDePagoGeneral && formasDePagoGeneral.length>0){

    //   let valorFormaPago = formasDePagoGeneral.reduce((acumulador:any, item:any) => acumulador + item.valorFormaPago, 0);
    //   datosAdicionales['totalPagado'] = valorFormaPago
    //   datosAdicionales['valorTotalDevolver'] = devolver
    // }
    let valoresDescuento = []
    if(valorDescuento > 0) {
      for(let i=0;i <listaProductosSeleccionados.length;i++){

        if(listaProductosSeleccionados[i].porcentajeDescuento > 0) {
          valoresDescuento.push({
              valorConDescuento:listaProductosSeleccionados[i].valorConDescuento,
              porcentajeDescuento:listaProductosSeleccionados[i].porcentajeDescuento,
              tipoProducto:listaProductosSeleccionados[i].tipoProducto,
              productosId:listaProductosSeleccionados[i].productosId
          });
       }
     }
     datosAdicionales['valorDescuento'] = JSON.stringify(valoresDescuento)
    }

    if(valorDeLaPropina.length>0) {
      datosAdicionales['valorDeLaPropina'] = JSON.stringify(valorDeLaPropina)
      // datosAdicionales['valorServicio'] = valorDeLaPropina[0].valor
    }
    let resVenta:any = await this.guardarVentaAsync(listaProductosSeleccionadosNuevosValores, datosAdicionales,elaboradosContenido,'','',formasDePagoGeneral)
    mesaSeleccionada = listaProductosSeleccionadosNuevosValores[0].numeromesa
    for(var k =0;k < listaProductosSeleccionadosNuevosValores.length;k++){
        if(mesaSeleccionada == listaProductosSeleccionadosNuevosValores[k].numeromesa){
            let datosComanda = {
                comandasId: listaProductosSeleccionadosNuevosValores[k].comandasId,
                estado: 'F',
                imagen: null,
                color: '#006400',
                queHago: "A",
                nombreTabla: "comandas",
                name: "dataDynamicCrud"
                }
              listaProductosSeleccionados = []
              this.actualizarComandas(datosComanda)
              .subscribe((data)=>{
              },(error)=>{
                console.log('error actualizarComandas', error)
              })
        } else {
          if(mesaSeleccionada == turno && listaProductosSeleccionadosNuevosValores[k].comandasId === comandasId){
            let consecutivo = JSON.parse(resVenta['_body']).data[0]
            let numeroFactura: string = ''; // Variable donde se guardará el número de factura
              consecutivo.forEach((item:any) => {
              if (item.reciboCaja.includes("Factura de Venta Nro:")) {
                // Extraer el número de factura
                const regex = /Factura de Venta Nro: (\d+)/;
                const match = item.reciboCaja.match(regex);
                if (match) {
                    numeroFactura = match[1]; // El número de factura se guarda en la variable
                }
            }})
              this.ActualizarComandasPorTurno(this.datosAdicionales.companiasId,turno,numeroFactura)
              .subscribe((data:any)=>{
              },(error:any)=>{
              })
        }
        }
    let dataJson =  resVenta['_body']
    let dataJsonParse = JSON.parse(dataJson)
    this.mostrarMensajeGeneral(dataJsonParse.data)
    let recibo = ''
    let mensaje =  dataJsonParse.data[0]
    for (let index:any = 0; index < mensaje.length; index++) {
      //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
      const textoRecibo = mensaje[index]['reciboCaja'];

      // Comandos ESC/POS para negrita y tamaño de fuente
      const negritaOn = '\x1b\x45\x01'; // Activar negrita
      const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
      const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
      const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
      const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

      if (textoRecibo.includes("TOTAL A PAGAR")) {
        recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
      } else {
        if(textoRecibo.includes("CAMBIO")) {
          recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
        } else {
          recibo += '   ' + textoRecibo + '\n';
        }
      }
    }
    if(deseaImprimir) {
      this.imprimirRecibo(recibo)
    }

  }
}

async generarVentaSinGestion(
  listaProductosSeleccionados: any[] = [],
  datosAdicionales: any = {},
  turnosArray: any[] = [],
  deseaImprimir: boolean,
  valorDescuento:Number=0,
  valorDeLaPropina:any
) {
  // Asignación de productos seleccionados si se proporcionan
  if (listaProductosSeleccionados.length > 0) {
    datosAdicionales.listaProductosSeleccionados = listaProductosSeleccionados;
  }

  try {
    // Obtener la fecha del sistema
    const fechaSistema = this.fechaVenta

    if (fechaSistema !== undefined && fechaSistema !== null) {
      datosAdicionales.fechaVenta = fechaSistema;
    }

    let elaboradosContenido = '';
    let turno = datosAdicionales.turno;
    let comandasId = datosAdicionales.comandasId;

    // Asignación de turno si no está definido
    if (turno === undefined || turno <= 0) {
      datosAdicionales.turno = turnosArray[0].turno;
      turno = datosAdicionales.turno;
    }

    // Asignación de comandasId si no está definido
    if (comandasId === undefined) {
      const cuantosLista = listaProductosSeleccionados.length - 1;
      comandasId = listaProductosSeleccionados[cuantosLista].comandasId;
      datosAdicionales.comandasId = comandasId;
    }

    // Guardar la venta
    const resVenta: any = await this.guardarVentaAsync(
      listaProductosSeleccionados,
      datosAdicionales,
      elaboradosContenido,
      ''
    )


      const dataJson = resVenta.data;
      const mensaje = dataJson;
      let recibo = '';

      const mensajes = Object.keys(mensaje).map(key => mensaje[key]);
      for (let index = 0; index < mensajes[0].length; index++) {
        recibo += mensajes[0][index].reciboCaja + '\n';
      }

      if (deseaImprimir) {
        this.imprimirRecibo(recibo).subscribe(
          res => {

          },
          err => {
            this.utils.mostrarReciboDeCajaEnPantalla('',mensaje)

              })
      }
  } catch (errVenta) {
    console.log('Error en la venta:', errVenta);
    // Manejo de errores
  }
}


mostrarMensajeGeneral(mensaje:any) {
  let recibo = ''
  let reciboBlue = ''
  let nuevovalorjsonBlue = ''
  if(MODO_DESCONECTADO){
      for (let index:any = 0; index < mensaje.length; index++) {
          recibo += mensaje[index]['reciboCaja'] + '\n'
      }
  }else{
      let newMensaje = NUBE_AWS ? mensaje : mensaje[0];
      if(newMensaje){

          let mensajes = NUBE_AWS ? Object.keys(mensaje).map(key => mensaje[key]) : mensaje[0]
          let recorrerMensaje = mensajes[0] !== undefined && mensajes[0][0] !== undefined ? mensajes[0] : mensajes
          for (let index:any = 0; index < recorrerMensaje.length; index++) {

              recibo += recorrerMensaje[index]['reciboCaja'] + '\n'
              reciboBlue +=   `{"reciboCaja":"${recorrerMensaje[index]['reciboCaja']}"},`;
          }

          var jsoncadena = reciboBlue;
          jsoncadena = jsoncadena.substr(jsoncadena.length - 1, 1) == ',' ? jsoncadena.substring(0, jsoncadena.length - 1) : jsoncadena;
          nuevovalorjsonBlue =  "[" + jsoncadena + "]";
     }
  }
}


async guardarVentaAsync(
  laVenta: any,
  datosAdicionales: any,
  elaboradosContenido: any,
  gestionarSimuladorCuotasExtras: any,
  cuentasPorCobrarCredito:any = '{}',
  metodosDePago:any = '{}'
) {
  try {
  const url_servicio = URL_SERVICIOS_AWS;
  const data = {
    name: "almacenarVentaDiariaAFN",
    parameters: {
      laVenta: JSON.stringify(laVenta),
      datosAdicionales: JSON.stringify(datosAdicionales),
      elaboradosContenido: elaboradosContenido,
      cuentasPorCobrarSimulador: JSON.stringify(gestionarSimuladorCuotasExtras),
      cuentasPorCobrarCredito: JSON.stringify(cuentasPorCobrarCredito),
      metodosDePago: JSON.stringify(metodosDePago)
    }
  };

  const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
  const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

  let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
  return response;
  } catch (error) {
    console.error('Error al guardar la venta:', error);
    throw error; // Propaga el error para que el llamador pueda manejarlo
  }
}

refactorizarValoresMesas(data:any){
  let listaProductosSeleccionados = []

  for(let i=0;i <data.length;i++){

      listaProductosSeleccionados.push({
          productosId:Number(data[i].productosId),
          tipoProducto:data[i].tipoProducto,
          cantidad:Number(data[i].cantidad),
          valorProducto: data[i].valorProductoIndividual == undefined ? Number(data[i].valorVenta) : Number(data[i].valorProductoIndividual),
          valorImpuesto: data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
          ubicacionesPorSalonesId:data[i].ubicacionesPorSalonesId,
          valorTotalImpuestos : data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
          valorTotalVenta : Number(data[i].valorTotalVenta),
          valorTotalProductos :  data[i].valorProductoIndividual == undefined ? Number(data[i].valorProducto) : Number(data[i].valorProductoIndividual),
          valorTotalDevolver: Number(data[i].valorTotalVenta),
          clienteId: data[i].clientesId,
          valormesa: data[i].numeromesa,
          comandasId: Number(data[i].comandasId),
          numeromesa:data[i].numeromesa,
          codigo:data[i].codigo,
          valorImpuestoCalculo: data[i].valorImpuestoCalculo,
          nombreProducto: data[i].nombreProducto,
          valorConDescuento:data[i].valorConDescuento !== undefined ? data[i].valorConDescuento : 0,
          porcentajeDescuento:data[i].porcentajeDescuento !== undefined ? data[i].porcentajeDescuento : 0,
          turno: data[i].turno,
          fecha: data[i].fecha
      });
  }
  return listaProductosSeleccionados
}


async buscarComandasTurno(companiasId:any,turno:any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarComandasTurno",
      parameters : {turno: turno,
        companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option

    let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response
    } catch (error) {
      // Manejo de errores
      console.error('Error en:', error);
      throw error;
    }
  }

  async buscarGruposProductosParaCajaTenderoPaginado(companiasId:any) {
    try {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "gruposProductosParaCajaTenderoPaginado",
        parameters : {
          companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option

      let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
      return response
      } catch (error) {
        // Manejo de errores
        console.error('Error en:', error);
        throw error;
      }
    }

    async buscarGruposProductosParaCajaVertical(companiasId:any) {
      try {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "gruposProductosParaCajaVertical",
          parameters : {
            companiasId: companiasId}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
        return response
        } catch (error) {
          // Manejo de errores
          console.error('Error en:', error);
          throw error;
        }
      }

    buscarProductosPaginadoInfinito(companiasId:any,pagina:any,cantidadPaginar:any,search:any=null, agrupaProductosEnCaja:any=0){
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let request = {
          name: "buscarProductosPaginadoInfinito",
          parameters : {companiasId:companiasId,pagina:pagina,cantidadPaginar:cantidadPaginar,search:search,agrupaProductosEnCaja}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, request, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
        .map((data) => data.json())
      }
    }

    abrirCajon() {
      const url = this.urlPrintService || URL_SERVICIOS_LOCALES_IMPRESORA;

      const headers = new Headers({
          'Content-Type': 'application/json'
      });

      const options = new RequestOptions({
          headers: headers
      });

      // Solo enviamos la señal para abrir el cajón, sin texto de impresión
      return this.http.post(url, { text: "", cut: false, cash: true }, options);
  }

  async actualizarPreciosDatosAdicionalesDinamico(productosSeleccionados:any,companiasId:any,impuestoPorDefectoAlCambiarNombre:any='SIN IMPUESTO') {
    try {
      let response;
       const url_servicio = URL_SERVICIOS_AWS;
        const valores = {
          name: "actualizarPreciosDatosAdicionalesDinamico",
          parameters: {
            productosSeleccionados:JSON.stringify(productosSeleccionados),
            companiasId:companiasId,
            impuestoPorDefectoAlCambiarNombre:impuestoPorDefectoAlCambiarNombre }
        };
        const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
        const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

        response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
        return response
    } catch (error) {
      console.error('Error en buscarCuentaPorCobrar:', error);
      throw error;
    }
  }

  async actualizarNombreProducto(companiasId:any,productosId:any,nombreProducto:any,valorVenta:any,tipoImpuesto:any,valorImpuesto:any) {
    try {
      let response;
       const url_servicio = URL_SERVICIOS_AWS;
        const valores = {
          name: "actualizarNombreProducto",
          parameters: {companiasId:companiasId,
            productosId:productosId,
            nombreProducto:nombreProducto,
            valorVenta:valorVenta,
            tipoImpuesto:tipoImpuesto,
            valorImpuesto:valorImpuesto}
        };
        const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
        const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

        response = await this.http.post(`${url_servicio}/procedure`, valores, options).toPromise();
        return response
    } catch (error) {
      console.error('Error en buscarCuentaPorCobrar:', error);
      throw error;
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/caja/caja.ts